import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Select, Radio, DatePicker } from 'antd';
import Draggable from 'react-draggable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import SelectCenter from "../util/SelectCenter";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from  "react-datepicker";
import ko from 'date-fns/locale/ko';
import { useSelector } from 'react-redux';
import moment from 'moment';
import setup from '../setup';
registerLocale('ko', ko)

const layout = {
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 9,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

function RewardPopup(props) {
    const [cid, setCid] = useState('');
    const [selectedCenter, setSelectedCenter] = useState('');
    const [title, setTitle] = useState('');
    const [takeDate, setTakeDate] = useState('');
    const data = useSelector(state => state.data);
    const [form] = Form.useForm();

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
        form.setFieldsValue({
            cid: cid
        });
    }

    function radioChange(e){
        console.log(e.target.value)
        let now = moment();
        if(e.target.value !== 'Y'){
            setTakeDate('0000-00-00')
            form.setFieldsValue({
                take_date: '0000-00-00'
            });
        }else{
            setTakeDate(now)
            form.setFieldsValue({
                take_date: now
            });
        }
    }

    const onFinish = (values) => {
        console.log(values);
        const { takeout_yn, take_date } = values;
        let format_take_date = moment(take_date).format('YYYY-MM-DD');
        
        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/hg_admin/edit_reward', {
                seq : props.data.seq,
                takeout_yn : takeout_yn,
                take_date : format_take_date,
            })
            if(result.data.ret == 'Y'){
                alert('등록되었습니다');
                props.closePopup("updated");
            }else{
                alert(result.data.msg)
            }
        })();
    };

    async function deleteCoupon(seq) {
        const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
        const result = await axios.post(api_host + '/hg_admin/delete_reward', {
            seq : seq
        })
        if(result.data.ret == 'Y'){
            alert('삭제되었습니다');
            props.closePopup("updated");
        }else{
            alert(result.data.msg)
        }
    }

    function handleDelete() {
        confirmAlert({
            title: '삭제 확인',
            message: props.data.name + "님의 티셔츠 수령 정보를 삭제하시겠습니까?",
            buttons: [
              {
                label: 'Yes',
                onClick: () => deleteCoupon(props.data.seq)
              },
              {
                label: 'No'
              }
            ]
          });
    }

    useEffect(()=>{
        console.log(props.data);
        if(props.mode === "edit"){
            setTitle("티셔츠 수령 관리");
            setTakeDate(props.data.take_date)
            form.setFieldsValue({
                takeout_yn: props.data.takeout_yn,
                take_date: moment(props.data.take_date)
            });
        }else{
            alert("정상적인 접근이 아닙니다.")
        }
    },[]);

    return(
        <div className="popup frequency">
            <Draggable handle=".handle">
            <div className="popupInner">
            <div className="handle">
            <h3>{title}</h3>
            <FontAwesomeIcon icon={faTimes} onClick={() => props.closePopup("")} className="closeIcon" />
            </div>
            <Form {...layout} form={form} onFinish={onFinish}>
            <Form.Item
                name="name"
                label="고객명"
            >
                {props.data.name}
            </Form.Item>
            <Form.Item
                name="cid"
                label="센터명"
            >
                <SelectCenter onSelectedCenter={handleSelectedCenter} defaultValue={cid} width="w-100" readOnly/>
            </Form.Item>
            <Form.Item
                name="level"
                label="레벨"
            >
                {props.data.level}
            </Form.Item>
            <Form.Item
                name="takeout_yn"
                label="수령여부"
            >
                <Radio.Group onChange={radioChange}>
                    <Radio value={"Y"}>수령</Radio>
                    <Radio value={""}>미수령</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name="take_date" label="수령일">
                {
                    takeDate === '0000-00-00' || takeDate === '1899-11-30' ? '0000-00-00' : <DatePicker />
                }
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">수정</Button>
                &nbsp;
                <Button type="danger" onClick={handleDelete}>삭제</Button>
            </Form.Item>
            </Form>
            </div>
            </Draggable>
        </div>
    )
}

export default RewardPopup;
